export const reviewData =  [
    {
      name: 'Aman Yadav',
      text: 'Good food, service and atmosphere\n\nFeels like homemade food',
      publishedAtDate: '2024-06-24T15:13:37.363Z',
      publishAt: '6 months ago',
      likesCount: 0,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjU6GS3QUDskK_6WOjRCU_RWUr7w5CrcQubq5jvZWdHVqIyLxWXerQ=s120-c-rp-mo-ba2-br100',
      isLocalGuide: true,
      reviewDetailedRating: { Food: 5, Service: 5, Atmosphere: 5 },
      totalScore: 4.4,
      stars: 5
    },
    {
      name: 'Randhir Karn',
      text: 'One of the best hotel in Rajbiraj',
      publishedAtDate: '2024-05-30T04:22:40.779Z',
      publishAt: '6 months ago',
      likesCount: 0,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjXACJCjQjnNf37Z9wtJyuvYyux3__s-saVL56dLZtoEPGOPwnOI=s120-c-rp-mo-ba3-br100',
      isLocalGuide: true,
      reviewDetailedRating: { Food: 4, Service: 5, Atmosphere: 5 },
      totalScore: 4.4,
      stars: 4
    },
    {
      name: 'Santosh Jha',
      text: 'I really loved it 😍',
      publishedAtDate: '2024-05-11T13:35:07.362Z',
      publishAt: '7 months ago',
      likesCount: 0,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjWft2pT7dBEn-ygEA-sNd79_kLLTCqRJpXvKtLyYy6N6JdP2LJnow=s120-c-rp-mo-ba4-br100',
      isLocalGuide: true,
      reviewDetailedRating: {},
      totalScore: 4.4,
      stars: 5
    },
    {
      name: 'suresh manandhar',
      text: 'Delicious food with good ambience.',
      publishedAtDate: '2024-03-30T13:12:26.869Z',
      publishAt: '8 months ago',
      likesCount: 11,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocKpEZj6QpLWTDVURY8Gf8TGTOO9D5TBoJRLHFluMj9r7OuYug=s120-c-rp-mo-br100',       
      isLocalGuide: false,
      reviewDetailedRating: { Food: 4, Service: 4, Atmosphere: 4 },
      totalScore: 4.4,
      stars: 5
    },
    {
      name: 'Bikash Shah',
      text: 'Food is delicious but delivery boy attitude very bad',
      publishedAtDate: '2024-03-22T10:56:08.672Z',
      publishAt: '9 months ago',
      likesCount: 1,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocJEYlCcUuh_7YNJ2cJfuuhmOFgcbJBb327jY5UgcD9OoK-HTQ=s120-c-rp-mo-br100',       
      isLocalGuide: false,
      reviewDetailedRating: { Food: 5, Service: 1 },
      totalScore: 4.4,
      stars: 5
    },
    {
      name: 'Chandan Mandal',
      text: 'Home warking',
      publishedAtDate: '2024-03-07T14:29:48.848Z',
      publishAt: '9 months ago',
      likesCount: 1,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocI3W23C2-fN8T_ryc4YwOilU3W6NoXRkU3RGC-vzI50EXMbfQ=s120-c-rp-mo-br100',       
      isLocalGuide: false,
      reviewDetailedRating: { Food: 5, Service: 5, Atmosphere: 5 },
      totalScore: 4.4,
      stars: 5
    },
    {
      name: 'Rachana',
      text: 'Best meal I’ve had in Nepal so far! The Reshmi kebab was exquisite. Chicken momos delicious. Biryanis were flawless. And a simple halva to end the meal. Only slight negative was the Chicken curry was a tad too salty.',
      publishedAtDate: '2024-03-01T02:44:58.274Z',
      publishAt: '9 months ago',
      likesCount: 3,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjUTJ99yrFWBx8i8RDANBJNH3ariinuYApO-yXAQguqqzRgv1-3Zbw=s120-c-rp-mo-br100',  
      isLocalGuide: false,
      reviewDetailedRating: { Food: 5, Service: 5, Atmosphere: 5 },
      totalScore: 4.4,
      stars: 5
    },
    {
      name: 'Sian Williams',
      text: 'Absolutely delicious. Mothers cooking at its best.  Very friendly service.',
      publishedAtDate: '2024-02-28T14:18:36.488Z',
      publishAt: '9 months ago',
      likesCount: 3,
      reviewerPhotoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjWgewbWKKixPfLMkoSBtARCVnA3uNZTdD-FoQPnCuUpMuJYpYXr=s120-c-rp-mo-ba4-br100',
      isLocalGuide: true,
      reviewDetailedRating: { Food: 5, Service: 5, Atmosphere: 5 },
      totalScore: 4.4,
      stars: 5
    }
  ]
